import React from "react"
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap"

import type { ActivityReportRow, TextEntryModalProps } from "./PlanLessonTypes"

interface ActivityReportModalProps {
  isOpen: boolean
  toggle: () => void
  title: string
  scoreLabel: string
  rows?: ActivityReportRow[]
}

function reportRowKey(topic: ActivityReportRow, index: number): string {
  return topic?.activity_node?.[0]?.node_name || `report-row-${index}`
}

export const ActivityReportModal = ({
  isOpen,
  toggle,
  title,
  scoreLabel,
  rows = [],
}: ActivityReportModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader className="mt-0" toggle={toggle}>
        {title}
      </ModalHeader>
      <ModalBody>
        <div className="table-responsive">
          <Table className="table table-striped mb-0">
            <thead>
              <tr>
                <th>Topic</th>
                <th>Questions Completed</th>
                <th>{scoreLabel}</th>
              </tr>
            </thead>
            <tbody>
              {rows.length > 0 ? (
                rows.map((topic, index) => (
                  <tr key={reportRowKey(topic, index)}>
                    <th scope="row">{topic?.activity_node?.[0]?.node_name}</th>
                    <td>{topic?.question_attended}</td>
                    <td>{topic?.masteryscore}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan={3}>No data</th>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  )
}

function TextEntryModal({
  isOpen,
  toggle,
  title,
  label,
  placeholder,
  value,
  rows,
  isSubmitting,
  onChange,
  onSave,
  inputId,
}: TextEntryModalProps) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader className="mt-0" toggle={toggle}>
        {title}
      </ModalHeader>
      <ModalBody>
        <div className="comment-section mt-3">
          <label className="font-size-15" htmlFor={inputId}>
            {label}
          </label>
          <textarea
            id={inputId}
            className="form-control"
            placeholder={placeholder}
            value={value}
            onChange={e => onChange(e.target.value)}
            rows={rows}
          />
        </div>
        <div className="text-end mt-3">
          <div className="btn-group">
            <button
              className="btn bg-danger text-white me-3 font-size-12"
              disabled={!!isSubmitting}
              onClick={onSave}
            >
              Save
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

interface TextModalVariantProps {
  isOpen: boolean
  toggle: () => void
  value: string
  isSubmitting?: boolean
  onChange: (value: string) => void
  onSave: () => void
}

export const TutorCommentModal = (props: TextModalVariantProps) => (
  <TextEntryModal
    {...props}
    title="Comment"
    label="Tutor Comment:"
    placeholder="Add your comment here"
    rows={3}
    inputId="commentTutor"
  />
)

export const TutorNoteModal = (props: TextModalVariantProps) => (
  <TextEntryModal
    {...props}
    title="Notes"
    label="Tutor Notes:"
    placeholder="Add your notes here"
    rows={10}
    inputId="notesTutor"
  />
)
